import React from "react";
import { NavLink } from "react-router-dom";
import "./sidebar.scss";
import TooltipWithHtml from "../../shared/htmlTooltip/TooltipWithHtml";
import bimifyLogo from "../../assets/images/bimify-logomark.svg";
import { getMenu } from "../../utils/sidebar";
import { isBimifyAdmin } from "../../utils/permission/user";
import SidebarSubmenu from "./SidebarSubmenu";

/**
 * Sidebar Component
 */

//Generate menu items based on role type and company type
const getMenuItems = () => {
	const menuItems = getMenu();

	return menuItems.map((item) => {
		const hasSubmenu = Array.isArray(item.submenu) && item.submenu.length > 0;
		const wrapperClasses = [
			"sidebar__link-wrapper",
			item?.wrapperClasses,
			hasSubmenu ? "sidebar__link-wrapper--has-submenu" : "",
		]
			.filter(Boolean)
			.join(" ");

		const navLink = (
			<NavLink
				isActive={(match, location) => {
					if (match) {
						return true;
					}
					if (!item?.activeRoutes?.length) {
						return false;
					}
					return item.activeRoutes.some((route) => {
						if (!route) {
							return false;
						}
						if (route === "/") {
							return location.pathname === route;
						}
						return (
							location.pathname === route ||
							location.pathname.startsWith(`${route}/`)
						);
					});
				}}
				to={item.route}
				className={item.class}
			>
				{item.image}
			</NavLink>
		);

		if (hasSubmenu) {
			return (
				<div key={item.route} className={wrapperClasses}>
					{navLink}
					<div className="sidebar__submenu-container">
						<SidebarSubmenu
							title={item.description}
							items={item.submenu}
							onItemClick={item.onSubmenuClick}
						/>
					</div>
				</div>
			);
		}

		const tooltipProps = {};
		if (item.tooltiptextClasses) {
			tooltipProps.tooltiptextClasses = item.tooltiptextClasses;
		}
		if (item.tooltipPlacement) {
			tooltipProps.tooltipPlacement = item.tooltipPlacement;
		}

		return (
			<div key={item.route} className={wrapperClasses}>
				<TooltipWithHtml tooltipContent={item.description} {...tooltipProps}>
					{navLink}
				</TooltipWithHtml>
			</div>
		);
	});
};

const Sidebar = () => {
	return (
		<div className="sidebar d-flex flex-column align-items-center pos-fix">
			<a
				href="https://bimify.com"
				target="_blank"
				className={`sidebar__home-link  ${isBimifyAdmin() ? "" : "mb-150"}`}
				rel="noopener noreferrer"
			>
				<TooltipWithHtml
					tooltipPlacement="right-start"
					tooltipContent={"Bimify home"}
				>
					<img src={bimifyLogo} alt="Bimify Home" />
				</TooltipWithHtml>
			</a>
			<nav className="sidebar__navigation d-flex flex-column justify-content-top h-100">
				{getMenuItems()}
			</nav>
		</div>
	);
};

export default Sidebar;
